import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Banner from '../../common/banner';
import Container from '../../common/container';
import PushTrainingLogo from '../../assets/push-training-logo.png';
import { useStores } from '../../store/rootStore';
import Phones from '../../assets/phones.png';
import PushPeople from '../../assets/people.png';
import {
  trackLandingPageGetStartedButtonTapped,
  trackLandingPagePageView,
} from '../../utils/analytics';

const LandingPage = () => {
  const { getNextPagePath } = useStores();
  const navigate = useNavigate();

  useEffect(() => {
    trackLandingPagePageView();
  }, []);

  const handleContinueButtonClick = (buttonDescrip: string) => {
    trackLandingPageGetStartedButtonTapped(buttonDescrip);
    navigate(getNextPagePath('GetStarted'));
  };

  const testimonials = [
    {
      context:
        '"Love the app! I feel myself becoming strong and better at running!"',
      icon: '💪',
      isLeftAligned: true,
    },
    {
      context: '"I\'m definitely seeing the improvements."',
      icon: '🔥',
      isLeftAligned: false,
    },

    {
      context: '"The app makes your running experience much more fun!"',
      icon: '🎉',
      isLeftAligned: true,
    },

    {
      context: '"Enjoying the pacing and alternating speeds for sure."',
      icon: '👏',
      isLeftAligned: false,
    },
  ];

  return (
    <>
      <Banner>
        <Flex
          justifyContent={'center'}
          width={'100%'}
          marginTop={'17px'}
          marginBottom={'17px'}
        >
          <Center>
            <Image
              src={PushTrainingLogo}
              width={'80px'}
              objectFit={'contain'}
            />
          </Center>
        </Flex>
      </Banner>
      <Container>
        <Flex direction={'row'}>
          <Flex direction={'column'} marginLeft={'21px'} marginTop={'45px'}>
            <Heading fontWeight={'900'} lineHeight={'normal'}>
              Treadmill Workouts You'll Love 🏃
            </Heading>
            <Flex justifyContent={'left'}>
              <Button
                marginTop={'15px'}
                bg={'#0E7AFE'}
                color={'white'}
                borderRadius={'3xl'}
                width={'137px'}
                height={'42px'}
                onClick={() => {
                  handleContinueButtonClick('Primary');
                }}
                _hover={{}}
                _focus={{}}
                _active={{}}
                style={{
                  backgroundImage:
                    'linear-gradient(-45deg, #007AFF 0%, #3094ff 50%, #007AFF 100%)',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '200% 100%',
                  backgroundPosition: '-200% 0',
                  animation: 'shimmerAndScaleAnimation 3s infinite linear',
                }}
              >
                Get Started
              </Button>
            </Flex>
          </Flex>
          <Image
            src={Phones}
            objectFit={'contain'}
            boxSize={'245px'}
            marginTop={'15px'}
          ></Image>
        </Flex>
        <Flex
          marginTop={'17px'}
          marginLeft={'27px'}
          marginRight={'27px'}
          justifyContent={'center'}
        >
          <Text
            fontSize={'17px'}
            textAlign={'center'}
            fontWeight={'590'}
            lineHeight={'normal'}
          >
            The #1 app fully dedicated to
            <br />
            treadmill interval runs.
          </Text>
        </Flex>
      </Container>
      <Box marginTop={'27px'}>
        <Banner>
          <Container>
            <Flex direction={'column'} marginTop={'37px'} marginBottom={'10px'}>
              {testimonials.map((testimonial) => (
                <Flex
                  direction={testimonial.isLeftAligned ? 'row' : 'row-reverse'}
                  marginBottom={'27px'}
                  paddingLeft={testimonial.isLeftAligned ? '17px' : '45px'}
                  paddingRight={testimonial.isLeftAligned ? '45px' : '17px'}
                >
                  <Box
                    fontSize={'20px'}
                    marginLeft={testimonial.isLeftAligned ? '0' : '4'}
                    marginRight={testimonial.isLeftAligned ? '4' : '0'}
                  >
                    {testimonial.icon}
                  </Box>
                  <Heading
                    fontSize={'20px'}
                    fontStyle={'italic'}
                    textAlign={testimonial.isLeftAligned ? 'left' : 'right'}
                  >
                    {testimonial.context}
                  </Heading>
                </Flex>
              ))}
            </Flex>
          </Container>
        </Banner>
      </Box>
      <Container>
        <Flex justifyContent={'center'}>
          <Button
            marginTop={'31px'}
            marginBottom={'31px'}
            bg={'#0E7AFE'}
            color={'white'}
            borderRadius={'3xl'}
            width={'90%'}
            height={'42px'}
            onClick={() => {
              handleContinueButtonClick('Bottom');
            }}
            _hover={{}}
            _focus={{}}
            _active={{}}
            style={{
              backgroundImage:
                'linear-gradient(-45deg, #007AFF 0%, #3094ff 50%, #007AFF 100%)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '200% 100%',
              backgroundPosition: '-200% 0',
              animation: 'shimmerAndScaleAnimation 3s infinite linear',
            }}
          >
            Get Started
          </Button>
        </Flex>
        <Flex
          width={'90%'}
          justifyContent={'center'}
          margin={'auto'}
          marginBottom={'44px'}
        >
          <Image
            src={PushPeople}
            boxSize={'350px'}
            objectFit={'contain'}
            width={'100%'}
            borderRadius={'2xl'}
          ></Image>
        </Flex>
      </Container>
    </>
  );
};

export default LandingPage;
